module.exports = __webpack_public_path__ + "static/SharpSansNo1-Medium-201ae0339b182fe949b993c97c792b0f.ttf";